<template>
    <MainContentSearchable title="Listado de precios" id="categorias" v-model="filters" :meta="loading ? {} : categorias.meta" @updated="getCategorias">
        <template v-slot:header>
            <h3>Listado de precios con su resumen</h3>
        </template>
        <template v-slot:content>
            <div :class="['table', { 'expanded': categorias.data.length <= 3 }]">
                <b-table hover :items="categorias.data" :fields="fields" id="categorias-table">
                    <template #cell(precio)="{ item }">
                        {{ item.precio | formatear_precio }}
                    </template>
                    <template #cell(opciones)="{ item, index }">
                        <OpcionesDropdownTableComponent 
                            :lastIndex="categorias.data.length > 3 && index >= categorias.data.length - 3"
                            v-bind:options="[
                                { to: { name: 'back.bases.categorias.resumen', params: { lista_id: lista_id, categoria_id: item.id } }, label: 'Resumen'}
                            ]"
                        />
                    </template>
                </b-table>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";

    export default {
        data() {
            return {
                categorias: {},
                loading: false,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                fields: [
                    { key: "id", label: "ID", class: 'text-center'},
                    { key: "name", label: "Nombre", class: 'text-center' },
                    { key: "precio", label: "Precio", class: 'text-center' },
                    { key: "total_deportistas", label: "Total de deportistas", class: 'text-center' },
                    { key: "media_edad", label: "Media de edad", class: 'text-center' },
                    { key: "opciones", label: "Acciones", class: 'text-center' }
                ]
            }
        },
        methods: {
            getCategorias() {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    filters: this.filters
                };
                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.index'), params).then(res => {
                    this.categorias = res.data;
                }).finally(() => this.loading = false);
            },
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        created() {
            this.getCategorias();
        },
        components: {
            MainContentSearchable,
            OpcionesDropdownTableComponent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>